"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useAnimationFrame = void 0;

var react_1 = require("react");

var useAnimationFrame = function useAnimationFrame(callback) {
  react_1.useEffect(function () {
    var requestAnimationFrameRef = 0;
    var previousTime = 0;

    var loop = function loop(time) {
      var deltaTime = time - previousTime;
      callback(deltaTime);
      previousTime = time;
      requestAnimationFrameRef = requestAnimationFrame(loop);
    };

    requestAnimationFrameRef = requestAnimationFrame(loop);
    return function () {
      return cancelAnimationFrame(requestAnimationFrameRef);
    };
  }, []);
};

exports.useAnimationFrame = useAnimationFrame;